import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { InputRef } from 'antd';
import { getPhoneInputMask, getPhoneInputMaskWithExtension } from 'utils';
import { InputProps } from './types';
import LabelWrapper from '../LabelWrapper';
import { StyledInput } from './StyledComponents';

export { Input as InputNew } from 'antd';

export { InputProps };

export const Input = React.forwardRef<InputRef, InputProps>(
  (
    {
      error,
      label,
      placeholder,
      size = 'middle',
      width,
      required,
      className,
      position = 'before',
      phoneNumberMask,
      phoneNumberMaskWithExtension,
      ...props
    },
    ref,
  ) => {
    const dataCy = (props as any)['data-cy'] ?? props.dataCy;
    const phoneRef = useRef<HTMLDivElement>();

    useEffect(() => {
      if (phoneNumberMask) {
        const input = (
          label ? phoneRef.current.children[1] : phoneRef.current.children[0]
        ) as HTMLInputElement;
        getPhoneInputMask().mask(input);
      }
    }, []);

    useEffect(() => {
      if (phoneNumberMaskWithExtension) {
        const input = (
          label ? phoneRef.current.children[1] : phoneRef.current.children[0]
        ) as HTMLInputElement;
        getPhoneInputMaskWithExtension().mask(input);
      }
    }, []);

    return (
      <LabelWrapper
        label={label}
        error={error}
        required={required}
        className={className}
        position={position}
        ref={phoneRef}
        {...(dataCy && {
          dataCy: `${dataCy}-container`,
        })}
      >
        <StyledInput
          {...props}
          $width={width}
          placeholder={
            placeholder ||
            (typeof label === 'string'
              ? label
              : phoneNumberMask || phoneNumberMaskWithExtension
              ? '(XXX) XXX-XXXX'
              : null)
          }
          size={size}
          required={required}
          ref={ref}
          data-cy={dataCy}
        />
      </LabelWrapper>
    );
  },
);

export { default as InputNumber } from './InputNumber';
export { default as InputTextArea } from './InputTextArea';

export default styled(Input)``;
